"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.media = exports.sizes = exports.FlexTheme = void 0;

var _styledComponents = require("styled-components");

var _polished = require("polished");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    @media (max-width: ", "em) {\n      ", "\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PrimaryTheme = '#825efb';
var PrimaryGrey = '#62707B';
var FlexTheme = {
  PrimaryColor: PrimaryTheme,
  PrimaryGrey: '#62707B',
  PrimaryBackground: '#F8F8F5',
  PrimaryGreen: '#59d973',
  PrimaryMint: '#95fd35',
  PrimaryRed: '#ea2a8a',
  PrimaryYellow: '#F2C02E',
  PrimaryOrange: '#EF7E23',
  PrimaryBlue: '#5BB1F2',
  SecondaryColor: '#be7efc',
  TetiaryColor: '#ecdbfe',
  PrimaryBorderColor: '#D8D8E3',
  PrimaryFade: '#F5F5F7',
  PrimaryInputOutline: '#9D9DB7',
  PrimaryFontSize: '12px',
  PrimaryLineHeight: '1.6em',
  PrimaryFontColor: '#707070',
  SecondaryFontColor: '#90705F',
  PrimaryFont: "'Inter', sans-serif",
  SecondaryFont: "'Avenir', sans-serif",
  TetiaryFont: "'Open Sans Light', sans-serif",
  PrimaryColor_light_80: (0, _polished.lighten)(0.4, PrimaryTheme),
  PrimaryColor_light_60: (0, _polished.lighten)(0.3, PrimaryTheme),
  PrimaryColor_light_40: (0, _polished.lighten)(0.2, PrimaryTheme),
  PrimaryColor_light_10: (0, _polished.lighten)(0.1, PrimaryTheme),
  PrimaryColor_dark_10: (0, _polished.darken)(0.1, PrimaryTheme),
  PrimaryGreyDark: (0, _polished.darken)(0.2, PrimaryGrey),
  PrimaryGreyMid: (0, _polished.lighten)(0.2, PrimaryGrey),
  PrimaryGreyLight: (0, _polished.lighten)(0.4, PrimaryGrey),
  PrimaryRadius: '3px',
  SecondaryRadius: '5px',
  PrimaryCellPad: '20px',
  SecondaryCellPad: '15px',
  PrimaryTransition: 'all 0.3s ease-out',
  // Elevation/Shadows
  // Elevator: (size, color) => {
  //   let sizer = {
  //     low: `box-shadow: 0 1px 3px`,
  //     mid: `box-shadow: 1px 3px 6px`,
  //     high: `box-shadow: 3px 6px 15px`,
  //   }
  //   return ``;
  // },
  Elevate: {
    low: "box-shadow: 0 1px 3px ".concat((0, _polished.transparentize)(0.9, (0, _polished.darken)(0.2, PrimaryTheme))),
    mid: "box-shadow: 1px 3px 6px ".concat((0, _polished.transparentize)(0.8, (0, _polished.darken)(0.3, PrimaryTheme))),
    high: "box-shadow: 1px 6px 15px ".concat((0, _polished.transparentize)(0.8, (0, _polished.darken)(0.3, PrimaryTheme))),
    fader: "box-shadow: 1px 1px 10px ".concat((0, _polished.transparentize)(0.9, (0, _polished.darken)(0.4, PrimaryTheme)))
  },
  // Icons Class Names: Overide default icon class names
  Icons: {
    next: 'flexibull-right',
    previous: 'flexibull-left',
    loader: 'flexibull-spin6'
  },
  Gradient: function Gradient(primary, secondary) {
    return "background: ".concat(primary, ";\n        background: -moz-linear-gradient(-45deg, ").concat(primary, " 0%, ").concat(secondary, " 100%);\n        background: -webkit-linear-gradient(-45deg, ").concat(primary, " 0%,").concat(secondary, " 100%);\n        background: linear-gradient(135deg, ").concat(primary, " 0%,").concat(secondary, " 100%);\n        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='").concat(primary, "', endColorstr='").concat(secondary, "',GradientType=1 );");
  },
  Truncate: function Truncate(width) {
    return "\n        width: ".concat(width, ";\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    ");
  }
};
exports.FlexTheme = FlexTheme;
var sizes = {
  large: 1170,
  desktop: 992,
  tablet: 768,
  phone: 660
};
exports.sizes = sizes;
var media = Object.keys(sizes).reduce(function (acc, label) {
  acc[label] = function () {
    return (0, _styledComponents.css)(_templateObject(), sizes[label] / 16, _styledComponents.css.apply(void 0, arguments));
  };

  return acc;
}, {});
exports.media = media;